import React, {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {IMenuTreeModel, UNASSIGNED_TREE} from './MenuModel'

type Props = {
  trees: IMenuTreeModel[]
  selectedTreeId: string
  onSelect: (treeId: string) => void
  onCreate: () => void
  onEdit: (tree: IMenuTreeModel) => void
  onDelete: (tree: IMenuTreeModel) => void
}

/** Menü Yönetimi üst çubuğu: menü ağacı seçimi ve ağaç ekle / düzenle / sil */
export const MenuTreeBar: FC<Props> = ({trees, selectedTreeId, onSelect, onCreate, onEdit, onDelete}) => {
  const selectedTree = trees.find((tree) => tree.id === selectedTreeId)
  return (
    <div className='d-flex flex-wrap align-items-center gap-3'>
      <i className='bi bi-diagram-3 fs-2 text-primary'></i>
      <select
        className='form-select form-select-solid w-auto'
        style={{minWidth: 260}}
        value={selectedTreeId}
        onChange={(event) => onSelect(event.target.value)}
      >
        {trees.map((tree) => (
          <option key={tree.id} value={tree.id}>
            {tree.name} ({tree.menuCount} menü)
          </option>
        ))}
        <option value={UNASSIGNED_TREE}>Ağaca bağlı olmayan menüler</option>
      </select>
      <button type='button' className='btn btn-sm btn-light-primary' onClick={onCreate}>
        <i className='bi bi-plus-lg'></i>
        Yeni Menü Ağacı
      </button>
      {selectedTree && (
        <>
          <button type='button' className='btn btn-sm btn-light' onClick={() => onEdit(selectedTree)}>
            <i className='bi bi-pencil'></i>
            Düzenle
          </button>
          <button type='button' className='btn btn-sm btn-light-danger' onClick={() => onDelete(selectedTree)}>
            <i className='bi bi-trash'></i>
            Sil
          </button>
        </>
      )}
      {selectedTree?.description && <span className='text-muted fs-7'>{selectedTree.description}</span>}
    </div>
  )
}

type FormProps = {
  show: boolean
  editingTree: IMenuTreeModel | null
  loading: boolean
  onClose: () => void
  onSubmit: (values: {name: string; description: string}) => void
}

/** Menü ağacı oluşturma / düzenleme */
export const MenuTreeFormModal: FC<FormProps> = ({show, editingTree, loading, onClose, onSubmit}) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    if (!show) return
    setName(editingTree?.name ?? '')
    setDescription(editingTree?.description ?? '')
    setSubmitted(false)
  }, [show, editingTree])

  return (
    <Modal show={show} onHide={onClose} dialogClassName='modal-dialog-centered' backdrop='static'>
      <form
        onSubmit={(event) => {
          event.preventDefault()
          setSubmitted(true)
          if (name.trim()) onSubmit({name: name.trim(), description: description.trim()})
        }}
      >
        <div className='modal-header'>
          <h5 className='modal-title'>{editingTree ? 'Menü Ağacını Düzenle' : 'Yeni Menü Ağacı'}</h5>
          <button type='button' className='btn-close' onClick={onClose} />
        </div>
        <div className='modal-body'>
          <div className='mb-5'>
            <label className='form-label fw-bold required'>Ağaç Adı</label>
            <input
              type='text'
              autoFocus
              maxLength={100}
              className={`form-control ${submitted && !name.trim() ? 'is-invalid' : ''}`}
              placeholder='Örn: İnsan Kaynakları, Araç Kiralama'
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
            {submitted && !name.trim() && <div className='invalid-feedback'>Ağaç adı zorunludur</div>}
          </div>
          <label className='form-label fw-bold'>Açıklama</label>
          <input
            type='text'
            maxLength={255}
            className='form-control'
            placeholder='Bu ağacın hangi yazılıma ait olduğu'
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </div>
        <div className='modal-footer'>
          <button type='button' className='btn btn-light' onClick={onClose}>
            İptal
          </button>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {loading ? <span className='spinner-border spinner-border-sm' /> : editingTree ? 'Güncelle' : 'Kaydet'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
